import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import dateHelper from '@utils/dates';
import { Spacings, mobile, Fonts } from '../../../styleConstants';
import SectionDescription from './SectionDescription';

const DateWrapper = styled(SectionDescription)`
  margin-top: ${Spacings.SPACING_8B};
  color: var(--color-i-black-3);
  @media only screen and (max-width: ${mobile.maxWidth}) {
    margin-top: ${Spacings.SPACING_4B};
    font-size: ${Fonts.H4};
  }
`;

const DateDelimeter = styled.span`
  color: var(--color-i-violet-7);
`;

const delimeters = [' • ', ' - '];

const SummitDate = ({ className }) => {
  const dates = useSelector(({ summit }) =>
    (summit.schedule || []).map((daySchedule) => daySchedule.date)
  );
  const dateText = useSelector(({ summit }) => summit.info?.dateText);
  if (dateText) {
    return <DateWrapper className={className}>{dateText}</DateWrapper>;
  }
  return dates.length > 0 ? (
    <DateWrapper className={className}>
      {dateHelper.getMonthString(dates[0])}
      &nbsp;
      {dates.map((date, index, srcArray) => (
        <>
          {dateHelper.getDay(date)}
          <DateDelimeter>
            {index === srcArray.length - 1 ? delimeters[1] : delimeters[0]}
          </DateDelimeter>
        </>
      ))}
      {dateHelper.getYear(dates[dates.length - 1])}
    </DateWrapper>
  ) : null;
};

SummitDate.propTypes = {
  className: PropTypes.string
};

SummitDate.defaultProps = {
  className: ''
};

export default SummitDate;
